import { Link } from "react-router-dom";

import { PageShell } from "../components/PageShell.js";
import { Seo } from "../components/Seo.js";

export function DownloadApp() {
  return (
    <PageShell>
      <Seo
        title="Download App · JivaSeva"
        description="The JivaSeva app is coming soon. Learn what we're building to make everyday acts of giving simpler, dignified, and accessible."
        path="/download-app"
      />
      <h1 className="page-heading">Download App</h1>
      <p className="callout">📱 The JivaSeva app is coming soon.</p>
      <p className="manifesto">
        We're still building the JivaSeva app, so it isn't available to download
        just yet. It will arrive as part of the fully digital phase of{" "}
        JivaSeva Giving — letting you keep a JivaSeva wallet, set your
        preferred donation amounts, and give instantly and anonymously with a
        quick QR-code scan.
      </p>
      <p className="manifesto">
        In the meantime, you can learn more about what we're building on the{" "}
        <Link to="/app" className="inline-link">
          JivaSeva Services
        </Link>{" "}
        page, or{" "}
        <Link to="/contact" className="inline-link">
          get in touch
        </Link>{" "}
        to stay updated and get involved.
      </p>
    </PageShell>
  );
}
